import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface AuthUser {
  id: number;
  username: string;
  realName: string;
  // v1.2-rc2 #5/#4：补 academic / academic_director，统一前端 role 联合类型
  role: 'admin' | 'director' | 'manager' | 'sales' | 'academic' | 'academic_director';
  /** P1-2: director 细分 — 'data'(看数据) / 'finance'(开发票) / null(通用) */
  directorType?: 'data' | 'finance' | null;
  teamId?: number | null;
  managerId?: number | null;
  isDeliveryLead?: boolean;
  avatarUrl?: string | null;
  // v1.4 RBAC 阶段 4 P0：权限点集合（后端 /auth/me + login 都带；旧 token 没此字段→undefined）
  permissions?: string[];
  dataScopeOverride?: 'self' | 'team' | 'department' | 'all' | 'custom' | null;
}

interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  user: AuthUser | null;
  mustChangePassword: boolean;
  setSession: (s: { accessToken: string; refreshToken: string; user: AuthUser; mustChangePassword?: boolean }) => void;
  setUser: (user: AuthUser) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      user: null,
      mustChangePassword: false,
      setSession: ({ accessToken, refreshToken, user, mustChangePassword }) =>
        set({ accessToken, refreshToken, user, mustChangePassword: !!mustChangePassword }),
      setUser: (user) => set({ user }),
      logout: () => set({ accessToken: null, refreshToken: null, user: null, mustChangePassword: false }),
    }),
    { name: 'huanke-auth' },
  ),
);
